module.exports = "<h2> Welcome to Recipe Book!</h2>\n"